module.exports = __webpack_public_path__ + "img/topimg.f378c92e.png";